import "../../../assets/css/tabs/addStaffDocuments.css";

import closeIcon from "../../../assets/images/close.svg"

import { Modal } from "react-bootstrap";
import { useRef } from "react";
import moment from "moment"
import useStaffPayroll from "./hooks/useStaffPayroll";
import { useAuth } from "../../../context/auth-user";

const URI_LOCALHOST = process.env.REACT_APP_URI_LOCALHOST

export default function AddDocumentsModal(props) {
	const { supplier, staffAssignmentId, onHide } = props

	const { user } = useAuth()
	const darkLightMode = user?.selectedProfile?.darkLightMode

	const inputRef = useRef(null)

	const {
		data: staffMember,
		payrollModal,
		handleCloseModal,
		handleAddStaffDocument,
		handleRemoveStaffDocument
	} = useStaffPayroll({
		supplier,
		staffAssignmentId,
		removeSelectedStaff: onHide
	})

	// FUNCTION TO HANDLE WHEN A FILE IS SILECTED
	const handleFileUpload = async (target) => {
		const file = target.files[0]

		if (!file) return

		handleAddStaffDocument(staffMember._id, file)

		target.value = ""
	}

	const handleDeleteStaffDocument = (documentId) => {
		handleRemoveStaffDocument(staffMember._id, documentId)
	}

	const closeModal = () => {
		handleCloseModal()

		setTimeout(() => {
			onHide()
		}, 500)
	}

	return (
		<Modal
			className={`staffAddDocuments ${darkLightMode ? "darkMode" : ""}`}
			show={payrollModal}
			onHide={closeModal}
			size="lg"
			aria-labelledby="contained-modal-title-vcenter"
			centered
		>
			<Modal.Body>
				<img className="closeIcon" src={closeIcon} alt="Prodensa Supplier" onClick={closeModal} />

				<div className="headerAndAdd">
					<input ref={inputRef} type="file" style={{ display: "none" }} accept="application/pdf" onChange={(e) => handleFileUpload(e.target)} />
					<h4>{staffMember?.name}</h4>
					<span>Payroll Receipts</span>
					<button className="btnBgBlueTextGradient" onClick={() => inputRef.current.click()}>New</button>
				</div>


				<div className="scrollableTable">
					<table>
						<thead>
							<tr>
								<th>
									<span>Document name</span>
								</th>
								<th>
									<span>Month</span>
								</th>
								<th>
									<span>Year</span>
								</th>
								<th>
									<span>Actions</span>
								</th>
							</tr>
						</thead>
						<tbody>
							{staffMember?.payrollReceipts.map(document => {
								const documentName = document?.document?.split(`${staffMember._id}/`)[1] || "Unknown Document";

								return (
									<tr key={document._id}>
										<td>
											<span>{documentName}</span>
										</td>
										<td>
											<span>{moment(`${document.monthCreatedAt}/${document.dayCreatedAt}/${document.yearCreatedAt}`)?.format("MMMM")}</span>
										</td>
										<td>
											<span>{moment(`${document.monthCreatedAt}/${document.dayCreatedAt}/${document.yearCreatedAt}`)?.format("YYYY")}</span>
										</td>
										<td>
											<span>
												<button className="downloadIcon" onClick={() => window.open(`${URI_LOCALHOST}${document.document}`, "_blank")} />
												<button className="deleteIcon" onClick={() => handleDeleteStaffDocument(document._id)} />
											</span>
										</td>
									</tr>
								)
							})}
						</tbody>
					</table>
				</div>
			</Modal.Body>
		</Modal>
	);
}